const pages = [
  // Auditor
  {
    name: "View mobile users",
    listName: "View mobile users",
    url: "/auditor-users",
    icon: "fa fa-tablet fa-lg",
    attributes: { "data-cy": "auditor-users" },
    permissions: [
      "FstIrohaAccountResource.getAllMobileIrohaAccounts",
      "ReportResource.getAllMobileIrohaAccounts",
      "FstIrohaAccountResource.getFstIrohaAccountWithIdentity",
    ],
  },
  {
    name: "Search mobile user",
    listName: "Search mobile user",
    url: "/mobile-user-search",
    icon: "fa fa-search fa-lg",
    attributes: { "data-cy": "mobile-user-search" },
    permissions: ["FstIrohaAccountResource.findIrohaAccountByPhone"],
  },
  {
    name: "History",
    listName: "History for auditor",
    url: "/auditor-history",
    icon: "fa fa-history fa-lg",
    attributes: { "data-cy": "history" },
    permissions: [
      "FstIrohaAccountResource.getAllFstIrohaAccountIds",
      "TransferManagementResource.getWebTransactionsHistory",
      "TransferManagementResource.getIrohaTransactionViewByIdAndDestAccountId",
    ],
  },
  // Authorizer
  {
    name: "Change Phone Requests",
    listName: "Authorize Change Phone Requests",
    url: "/change-phone-requests",
    icon: "fa fa-dashboard fa-lg",
    attributes: { "data-cy": "change-phone-requests" },
    permissions: [
      "ReplaceUserPhoneResource.reject",
      "ReplaceUserPhoneResource.authorize",
      "ReplaceUserPhoneResource.requests",
    ],
  },
  {
    name: "Authorize recovery requests",
    listName: "Authorize recovery requests",
    url: "/recovery-requests",
    icon: "fa fa-dashboard fa-lg",
    attributes: { "data-cy": "recovery-requests" },
    permissions: [
      "AccountRecoveryResource.requests",
      "AccountRecoveryResource.authorize",
      "AccountRecoveryResource.reject",
    ],
  },
  // Manager
  {
    name: "Dashboard",
    listName: "Dashboard",
    url: "/dashboard",
    icon: "fa fa-dashboard fa-lg",
    attributes: { "data-cy": "dashboard" },
    permissions: [
      "IrohaAccountResource.getAllIrohaAccountSummary",
      "TransferManagementResource.getTodayIncomingIrohaTransactions",
      "TransferManagementResource.getTodayOutgoingIrohaTransactions",
      "ReportResource.getOutgoingIrohaTransactions",
      "ReportResource.getIncomingIrohaTransactions",
    ],
  },
  {
    name: "Total Accounts",
    listName: "Total Accounts",
    url: "/total_account",
    icon: "fa fa-dashboard fa-lg",
    attributes: { "data-cy": "total-accounts" },
    permissions: [
      "IrohaAccountResource.getAllIrohaAccountSummary",
      "TransferManagementResource.getIrohaTransactionDetailsById",
      "BalanceInquiryResource.getAllBalances",
      "ParticipantBankBranchResource.getAllParticipantBankBranches",
      "ParticipantBankBranchResource.addIrohaAccountsToBranch",
      "ParticipantBankBranchResource.removeIrohaAccountsFromBranch",
      "FstIrohaAccountResource.getAllFstIrohaAccounts",
      "ReportResource.getAllFstIrohaAccounts",
      "TransferManagementResource.getMobileTransactionsByAccountId",
      "FstIrohaAccountResource.getFstIrohaAccountWithIdentity",
      "ReportResource.getIrohaTransactionsByAccountId",
    ],
  },
  {
    name: "Main Account",
    listName: "Main Account",
    url: "/main_account",
    icon: "fa fa-dashboard fa-lg",
    attributes: { "data-cy": "main-account" },
    permissions: ["BalanceInquiryResource.getAllBalances"],
  },
  {
    name: "Manage Main Account",
    listName: "Manage Main Account",
    url: "/manage_main_account",
    icon: "fa fa-money fa-lg",
    attributes: { "data-cy": "manage-main-account" },
    permissions: [
      "WalletTransferResource.paymentGatewayWalletTransfer",
      "BalanceInquiryResource.getAllBalances",
      "FstIrohaAccountResource.findIrohaAccountByAccountName",
    ],
  },
  {
    name: "Incoming Transactions",
    listName: "Incoming Transactions",
    url: "/incoming_transactions",
    icon: "icon-arrow-down-circle",
    attributes: { "data-cy": "incoming-transactions" },
    permissions: [
      "TransferManagementResource.acknowledge",
      "TransferManagementResource.refund",
      "TransferManagementResource.getIncomingIrohaTransactions",
      "TransferManagementResource.getIrohaTransactionDetailsByIdAndAccountId",
      "ReportResource.getIncomingIrohaTransactions",
    ],
  },
  {
    name: "Outgoing Transactions",
    listName: "Outgoing Transactions",
    url: "/outgoing_transactions",
    icon: "icon-arrow-up-circle",
    attributes: { "data-cy": "outgoing-transactions" },
    permissions: [
      "TransferManagementResource.getOutgoingIrohaTransactions",
      "TransferManagementResource.getIrohaTransactionDetailsByIdAndAccountId",
      "ReportResource.getOutgoingIrohaTransactions",
    ],
  },
  {
    name: "History",
    listName: "History for admin",
    url: "/history",
    icon: "fa fa-history fa-lg",
    attributes: { "data-cy": "history" },
    permissions: [
      "FstIrohaAccountResource.getAllFstIrohaAccountIds",
      "TransferManagementResource.getWebTransactionsHistory",
      "TransferManagementResource.getIrohaTransactionViewByIdAndDestAccountId",
      "ReportResource.getWebTransactionsHistory",
      "FstIrohaAccountResource.findAccountIdsStartingWith",
    ],
  },
  // {
  //   name: "Merchants",
  //   listName: "Merchants",
  //   url: "/merchant",
  //   icon: "fa fa-map fa-lg",
  //   attributes: { "data-cy": "merchants" },
  //   children: [
  //     {
  //       name: "Merchants list",
  //       url: "/merchants",
  //       icon: "fa fa-map-marker fa-lg",
  //       attributes: { "data-cy": "merchants-list" },
  //       permissions: [],
  //     },
  //     {
  //       name: "Merchant requests",
  //       url: "/merchant-requests",
  //       icon: "fa fa-map-marker fa-lg",
  //       attributes: { "data-cy": "merchants-requests" },
  //       permissions: [],
  //     },
  //   ],
  // },

  // Admin
  {
    name: "Waiting for Approval",
    listName: "Waiting for Approval",
    url: "/waiting_for_approval",
    icon: "fa fa-hourglass fa-lg",
    children: [
      {
        name: "Mobile requests",
        listName: "Mobile requests",
        url: "/waiting_for_approval/mobile",
        icon: "fa fa-mobile fa-lg",
        attributes: { "data-cy": "mobile-wfa" },
        permissions: [
          "VerificationRequestResource.getAllMobileVerificationRequests",
          "ReportResource.getAllMobileVerificationRequests",
          "KycLimitResource.getAllActiveKycLimits",
          "VerificationRequestResource.approveVerificationRequest",
          "VerificationRequestResource.rejectVerificationRequest",
          "FstIrohaAccountResource.getFstIrohaAccountWithIdentity",
          "VerificationRequestResource.getVerificationRequest",
          "ReplaceUserPhoneResource.createRequest",
          "ReplaceUserPhoneResource.verify",
          "UserResource.setUserFrozen",
          "UserResource.unsetUserFrozen",
          "UserResource.smsOtpByAccountName",
          "AccountRecoveryResource.prepareAccountRecoveryRequest",
          "AccountRecoveryResource.verifyAccountRecoveryRequest",
          "AccountRecoveryResource.accountRecoveryRequest",
          "FstIrohaAccountResource.update",
          "VerificationRequestResource.getActiveRequest",
        ],
      },
      {
        name: "Desktop requests",
        listName: "Desktop requests",
        url: "/waiting_for_approval/desktop",
        icon: "fa fa-laptop fa-lg",
        attributes: { "data-cy": "desktop-wfa" },
        permissions: [
          "VerificationRequestResource.getAllDesktopVerificationRequests",
          "ReportResource.getAllDesktopVerificationRequests",
          "KycLimitResource.getAllActiveKycLimits",
          "VerificationRequestResource.approveVerificationRequest",
          "VerificationRequestResource.rejectVerificationRequest",
          "FstIrohaAccountResource.getFstIrohaAccountWithIdentity",
          "VerificationRequestResource.getVerificationRequest",
          "UserResource.setUserFrozen",
          "UserResource.unsetUserFrozen",
          "AccountRecoveryResource.accountRecoveryRequest",
          "UserResource.removeAuthorizer",
          "UserResource.addAuthorizerToUserByAdmin",
        ],
      },
    ],
  },
  {
    name: "Mobile Users",
    listName: "Mobile Users",
    url: "/mobile-users",
    icon: "fa fa-tablet fa-lg",
    attributes: { "data-cy": "mobile-users" },
    permissions: [
      "FstIrohaAccountResource.getAllMobileIrohaAccounts",
      "FstIrohaAccountResource.setFstIrohaAccountLimits",
      "FstIrohaAccountResource.getFstIrohaAccountWithIdentity",
      "FstIrohaAccountResource.update",
      "ReportResource.getAllMobileIrohaAccounts",
      "KycLimitResource.getAllActiveKycLimits",
      "AccountRecoveryResource.accountRecoveryRequest",
      "UserResource.setUserFrozen",
      "UserResource.unsetUserFrozen",
      "ReplaceUserPhoneResource.createRequest",
      "ReplaceUserPhoneResource.verify",
      "AccountRecoveryResource.prepareAccountRecoveryRequest",
      "AccountRecoveryResource.verifyAccountRecoveryRequest",
      "VerificationRequestResource.getActiveRequest",
      "UserResource.smsOtpByAccountName",
      "VerificationRequestResource.approveVerificationRequest",
      "VerificationRequestResource.rejectVerificationRequest",
    ],
  },
  {
    name: "Desktop Users",
    listName: "Desktop Users",
    url: "/desktop-users",
    icon: "fa fa-tv fa-lg",
    attributes: { "data-cy": "desktop-users" },
    permissions: [
      "FstIrohaAccountResource.getAllDesktopIrohaAccounts",
      "FstIrohaAccountResource.getFstIrohaAccountWithIdentity",
      "FstIrohaAccountResource.setFstIrohaAccountLimits",
      "ReportResource.getAllDesktopIrohaAccounts",
      "KycLimitResource.getAllActiveKycLimits",
      "AccountRecoveryResource.accountRecoveryRequest",
      "UserResource.setUserFrozen",
      "UserResource.unsetUserFrozen",
      "UserResource.addAuthorizerToUserByAdmin",
      "UserResource.removeAuthorizer",
      "VerificationRequestResource.getActiveRequest",
    ],
  },
  {
    name: "Key recovery requests",
    listName: "Key recovery requests",
    url: "/key_recovery_requests",
    icon: "fa fa-repeat fa-lg",
    permissions: [
      "AccountRecoveryResource.prepareAccountRecoveryRequest",
      "AccountRecoveryResource.verifyAccountRecoveryRequest",
      "AccountRecoveryResource.accountRecoveryRequests",
      "AccountRecoveryResource.accountRecoveryClose",
      "AccountRecoveryResource.accountRecoveryRevoke",
      "AccountRecoveryResource.accountRecoveryRequest",
    ],
  },
  {
    name: "KYC Limit Amount",
    listName: "KYC Limit Amount",
    url: "/kyc-limit-amount",
    icon: "fa fa-gears fa-lg",
    attributes: { "data-cy": "kyc-limit-amount" },
    children: [
      {
        name: "Add Limit",
        listName: "Add Limit",
        url: "/kyc-limit-add",
        icon: "fa fa-gear fa-lg",
        attributes: { "data-cy": "add-limit" },
        permissions: ["KycLimitResource.createKycLimitLocal"],
      },
      {
        name: "Mobile Limit",
        listName: "Mobile Limit",
        url: "/kyc-limit-amount/mobile-limit",
        icon: "fa fa-gear fa-lg",
        attributes: { "data-cy": "mobile-limit" },
        permissions: [
          "KycLimitResource.getAllMobileKycLimits",
          "ReportResource.getAllMobileKycLimits",
          "KycLimitResource.updateKycLimitLocal",
          "KycLimitResource.getKycLimit",
        ],
      },
      {
        name: "Desktop Limit",
        listName: "Desktop Limit",
        url: "/kyc-limit-amount/desktop-limit",
        icon: "fa fa-gear fa-lg",
        attributes: { "data-cy": "desktop-limit" },
        permissions: [
          "KycLimitResource.getAllDesktopKycLimits",
          "ReportResource.getAllDesktopKycLimits",
          "KycLimitResource.updateKycLimitLocal",
          "KycLimitResource.getKycLimit",
        ],
      },
    ],
  },
  {
    name: "Change Phone Requests",
    listName: "Change Phone Requests for admin",
    url: "/change-phone-requests-admin",
    icon: "fa fa-dashboard fa-lg",
    attributes: { "data-cy": "change-phone-requests" },
    permissions: [
      "FstIrohaAccountResource.changePhoneNumber",
      "ReplaceUserPhoneResource.verify",
      "ReplaceUserPhoneResource.resendSms",
      "ReplaceUserPhoneResource.cancel",
      "ReplaceUserPhoneResource.requests",
    ],
  },
  {
    name: "Terms & Conditions",
    listName: "Terms & Conditions",
    url: "/terms_and_conditions",
    icon: "fa fa-book fa-lg",
    attributes: { "data-cy": "termsAndConditions" },
    children: [
      {
        name: "Mobile terms",
        listName: "Mobile terms",
        url: "/terms_and_conditions/mobile",
        icon: "fa fa-file-text fa-lg",
        attributes: { "data-cy": "mobile-termsAndConditions" },
        permissions: [
          "BankPropertyResource.updateMobilTc",
          "BankPropertyResource.getBatchSign",
        ],
      },
      {
        name: "Desktop terms",
        listName: "Desktop terms",
        url: "/terms_and_conditions/desktop",
        icon: "fa fa-file-text fa-lg",
        attributes: { "data-cy": "desktop-termsAndConditions" },
        permissions: [
          "BankPropertyResource.updateDesktopTc",
          "BankPropertyResource.getBatchSign",
        ],
      },
    ],
  },
  {
    name: "Bank contact information",
    listName: "Bank contact information",
    url: "/view_bank_info",
    icon: "fa fa-info-circle fa-lg",
    attributes: { "data-cy": "bank-info" },
    permissions: [
      "ParticipantBankResource.getParticipantBankInfoWeb",
      "ParticipantBankResource.setParticipantBankInfo",
      "ParticipantBankResource.getBankLogoWrapped",
      "ParticipantBankResource.getBankTitleLogo",
    ],
  },
];

export const flatPages = pages.flatMap(p => (p.children ? p.children : p));

export function getPages(page = 0, size = 10, filter) {
  const pages = filter
    ? flatPages.filter(p => p.name.toLowerCase().includes(filter.toLowerCase()))
    : flatPages;

  return pages.slice(page * size, size * (+page + 1));
}

export function getPagesByPermissions(permissions) {
  return flatPages.filter(
    p =>
      p.permissions.length &&
      p.permissions.every(per => permissions.includes(per)),
  );
}

export function getPermissionsByPages(pages) {
  const permissions = flatPages
    .filter(p => pages.includes(p.listName))
    .flatMap(p => p.permissions);

  return [...new Set(permissions)];
}

export default pages;
